import * as React from 'react';
import { Menu } from '@mui/material';

interface Props {
  label: React.ReactNode;
  active?: boolean;
}

export const Dropdown: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const { label, children, active } = props;
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClick: React.MouseEventHandler<HTMLDivElement> = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <div
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <div
          className={`flex space-x-1 items-end py-1 px-4 rounded-md text-blue-300 font-semibold cursor-pointer ${
            active ? 'text-white ' : 'text-blue-400'
          } hover:bg-darkblue-900`}
        >
          {label}
        </div>
      </div>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        style={{
          zIndex: '1500',
        }}
      >
        {children}
      </Menu>
    </div>
  );
};
